import React, { useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useEffect } from 'react'
import { loadFeatures } from 'Actions/data-actions'

export default function DataProvider({ children }) {
  const dataLoaded = useRef(false);
  const userToken = useSelector(state => state.User.token);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!userToken || dataLoaded.current) return;
    dispatch(loadFeatures());
    dataLoaded.current = true;
  }, [userToken]);

  return <>{children}</>;
}
